import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardShell from '../components/DashboardShell';
import './Home.css';
import './Dashboard.css';

const TILES = [
  {
    key: 'shoot-plan',
    label: 'Shoot Plan',
    description: 'Plan, review, and track every shoot from brief to delivery.',
    path: '/shoot-plans',
  },
  {
    key: 'lead-quality-score',
    label: 'Lead Quality Score',
    description: 'Score every lead generated through Meta Ads and Google Ads.',
    path: '/lead-quality-score',
  },
  {
    key: 'instagram-scheduler',
    label: 'Instagram Reel/Post Scheduler',
    description: 'Plan, schedule, and publish Instagram posts and reels.',
    path: '/instagram-scheduler',
  },
];

/** Central hub every role lands on after login. */
export default function Dashboard() {
  const navigate = useNavigate();

  return (
    <DashboardShell>
      <div className="rr-page" style={{ minHeight: 0, flex: 1 }}>
        <div className="rr-page__body">
          <div className="rr-page__eyebrow">Rush Republic</div>
          <h1 className="rr-page__title">Dashboard</h1>

          <div className="rr-dashboard-grid">
            {TILES.map((tile) => (
              <button
                key={tile.key}
                type="button"
                className="rr-dashboard-tile"
                onClick={() => navigate(tile.path)}
              >
                <span className="rr-dashboard-tile__label">{tile.label}</span>
                <span className="rr-dashboard-tile__desc">{tile.description}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </DashboardShell>
  );
}
